import { render } from "./CIS-Latest-Insights-Item.vue?vue&type=template&id=cd8ab6de"
import script from "./CIS-Latest-Insights-Item.vue?vue&type=script&lang=js"
export * from "./CIS-Latest-Insights-Item.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__